import { render, staticRenderFns } from "./BulkActionView.vue?vue&type=template&id=a4af93f8&"
import script from "./BulkActionView.vue?vue&type=script&lang=js&"
export * from "./BulkActionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports